import {Component, Injector, OnInit} from '@angular/core';
import {BaseComponent} from '../../base.component';
import {RouteUtil} from '../../../util/route.util';
import {Config} from '../../../common/config';
import {DeviceService} from '../../../util/service/device.service';

@Component({
  selector: 'app-account',
  standalone: false,
  templateUrl: './account.component.html',
  styleUrl: './account.component.scss'
})
export class AccountComponent extends BaseComponent implements OnInit {
  isMobile?: boolean;
  activeTab = 0;
  protected readonly RouteUtil = RouteUtil;
  protected readonly Config = Config;

  constructor(injector: Injector, deviceService: DeviceService) {
    super(injector);
    this.isMobile = deviceService.isMobile();
  }

  override ngOnInit() {
    super.ngOnInit();
  }

  override loadOnline() {
    super.loadOnline();
  }

  changeTab(index: number) {
    this.activeTab = index;
    switch (index) {
      case 0:
        this.router.navigate([RouteUtil.CLIENT_MODULE, RouteUtil.ACCOUNT_COMPONENT, RouteUtil.PROFILE_COMPONENT]).then();
        break;
      case 1:
        this.router.navigate([RouteUtil.CLIENT_MODULE, RouteUtil.ACCOUNT_COMPONENT, RouteUtil.ORDERS_COMPONENT]).then();
        break;
      case 2:
        this.router.navigate([RouteUtil.CLIENT_MODULE, RouteUtil.ACCOUNT_COMPONENT, RouteUtil.FAVORITE_COMPONENT]).then();
        break;
      case 3:
        this.router.navigate([RouteUtil.CLIENT_MODULE, RouteUtil.ACCOUNT_COMPONENT, RouteUtil.ADDRESS_COMPONENT]).then();
        break;
      case 4:
        this.router.navigate([RouteUtil.DASHBOARD_MODULE, RouteUtil.HOME_COMPONENT]).then();
        break;
    }
  }

  openBackClicked() {
    this.router.navigate([RouteUtil.CLIENT_MODULE]).then();
  }

  onSignOutClicked() {
    this.serviceApi.logout().subscribe((res: any) => {
      if (res === true) {
        Config.userInformation = null;
        this.router.navigate([RouteUtil.COMMON_MODULE]).then();
      }
    });
  }
}
